import {ModuleWithProviders, NgModule, Optional, SkipSelf, ErrorHandler} from "@angular/core";
import {ErrorService} from "./error.service";
import {GlobalErrorHandler} from "./global-error.handler";

@NgModule({})
export class ErrorModule {
    constructor(@Optional() @SkipSelf() parentModule: ErrorModule) {
        if (parentModule) {
            throw new Error('ErrorModule is already loaded. Import it in the AppModule only');
        }
    }

    /**
     * Provide the ErrorService.
     * @return ModuleWithProviders
     */
    static forRoot(): ModuleWithProviders<ErrorModule> {
        return {
            ngModule: ErrorModule,
            providers: [ErrorService, {provide: ErrorHandler, useClass: GlobalErrorHandler}]
        };
    }
}
